<template>
  <div class="top-content">
    <div class="container">
      <div class="header">
        <h1 class="header-title">{{ AppConst.APP_NAME }}</h1>
        <div class="header-description">
          <p>あなただけのオリジナルな家紋を作りましょう！</p>
          <p>背景は好みの画像をアップロードすることも可能です！</p>
        </div>
      </div>
      <div class="pickup-wrapper">
        <h2 class="content-title">おすすめの家紋</h2>
        <div class="pickup-content">
          <!-- 画面を水平に流れるようにアニメーションさせる
                NOTE: 途切れることなく無限ループさせるために、同じ画像群を2つ並べることで実現している -->
          <ul v-for="cnt in [1, 2]" :key="cnt" class="pickup-list">
            <li
              v-for="no in [...Array(pickupNoMax).keys()].map((i) => ++i)"
              :key="no"
              class="pickup-item"
            >
              <img
                :key="no"
                :src="pickupImgSrc(no)"
                class="pickup-img"
                @click="openPickupDetailModal(no)"
              />
            </li>
          </ul>
        </div>
      </div>
      <div class="entry-wrapper">
        <label class="entry-check-content">
          <input
            type="checkbox"
            class="entry-check-box"
            @click="canClickEntryBtn = !canClickEntryBtn"
          />
          <span class="entry-check-text">
            <a
              href="#term-modal"
              class="term-text"
              @click.prevent.stop="openTermModal"
            >
              利用規約</a
            >に同意する
          </span>
        </label>
        <EnterButton
          class="btn-entry"
          :class="{ 'disabled-button': !canClickEntryBtn }"
          @click="onClickEntryBtn"
        >
          家紋を作る
        </EnterButton>
      </div>
      <PickupModal
        v-show="showPickupDetailModal"
        :img-src="pickupDetailImgSrc"
        @close="closePickupDetailModal"
      />
      <Modal v-show="showTermModal" id="term-modal" @close="closeTermModal">
        <template #content>
          <div class="term-content" v-html="term" />
        </template>
      </Modal>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, onMounted, onUnmounted, ref } from "vue";
import { useRouter } from "vue-router";
//import { useGlobalStore } from "@/stores/global";
import EnterButton from "@/components/EnterButton.vue";
import Modal from "@/components/Modal.vue";
import PickupModal from "@/components/PickupModal.vue";
import marked from "marked";
import termMd from "@/assets/term.md";
import AppConst from "@/consts/app-const.ts";

/**
 *
 */
export default defineComponent({
  name: "Top",
  components: {
    EnterButton,
    Modal,
    PickupModal,
  },
  props: {},
  setup() {
    const router = useRouter();
    const toSelect = () => router.push({ name: "select" });

    // NOTE: 対象画像名は連番である必要あり
    //const pickupNoMin = 1;
    const pickupNoMax = 8; // XXX: 対象数に応じて値変更
    const pickupDetailImgSrc = ref<String>("");

    const showPickupDetailModal = ref<Boolean>(false);
    const showTermModal = ref<Boolean>(false);
    const canClickEntryBtn = ref<Boolean>(false);

    const term = marked(termMd);

    onMounted(() => {});

    onUnmounted(() => {});

    function onClickEntryBtn() {
      toSelect();
    }

    function openPickupDetailModal(pickupNo) {
      showPickupDetailModal.value = true;
      pickupDetailImgSrc.value = pickupImgSrc(pickupNo);
    }

    function closePickupDetailModal() {
      showPickupDetailModal.value = false;
    }

    function pickupImgSrc(pickupNo: number) {
      return "/app/assets/img/top_pickup/pickup_" + pickupNo + ".png";
    }

    function openTermModal() {
      showTermModal.value = true;
    }

    function closeTermModal() {
      showTermModal.value = false;
    }

    return {
      pickupNoMax,
      pickupImgSrc,
      pickupDetailImgSrc,
      onClickEntryBtn,
      openPickupDetailModal,
      closePickupDetailModal,
      showPickupDetailModal,
      canClickEntryBtn,
      openTermModal,
      closeTermModal,
      showTermModal,
      term,
      AppConst,
    };
  },
});
</script>

<style scoped>
@import "/app/assets/css/style.css";
.header {
  height: 10%;
}

.header .header-title {
  text-align: center;
  font-size: 8rem;
  font-family: "Sawarabi Mincho", sans-serif;
}

.header .header-description {
  font-size: 2rem;
  text-align: center;
}

.content-title {
  margin-left: 2rem;
  font-size: 2rem;
  font-family: "Sawarabi Mincho", sans-serif;
}

.pickup-wrapper {
  display: flex;
  flex-flow: column;
  margin-top: 4rem;
}

.pickup-content {
  display: flex;
  position: relative;
  height: 30%;
  width: 100%;
  overflow: hidden;
}
.pickup-content .pickup-list {
  display: flex;
  list-style-type: none;
}
.pickup-content .pickup-list:first-child {
  animation: loop 40s -20s linear infinite;
}
.pickup-content .pickup-list:last-child {
  animation: loop2 40s linear infinite;
}
.pickup-content:hover .pickup-list {
  animation-play-state: paused;
}
.pickup-img {
  width: 20vw;
}
.pickup-img:hover {
  border: 2px rgb(133, 133, 133) solid;
}
.term-text {
  text-decoration: underline;
  color: rgb(13, 43, 107);
}

@keyframes loop {
  0% {
    transform: translateX(100%);
  }
  to {
    transform: translateX(-100%);
  }
}

@keyframes loop2 {
  0% {
    transform: translateX(0);
  }
  to {
    transform: translateX(-200%);
  }
}

.entry-wrapper {
  display: flex;
  flex-flow: column;
  justify-content: center;
  align-items: center;
  height: 20%;
  margin: 4rem;
}

.entry-check-content {
  display: flex;
  align-items: center;
}

.entry-check-text {
  margin-left: 0.5rem;
  font-size: 1.5rem;
}

.btn-entry {
  margin: 2rem;
}

.disabled-button {
  pointer-events: none;
  cursor: not-allowed;
  opacity: 0.65;
  filter: alpha(opacity=65);
  -webkit-box-shadow: none;
  box-shadow: none;
}

.term-content {
  background-color: white;
  text-align: left;
  overflow: scroll;
  height: 80vh;
  padding: 4rem;
  margin-top: 4rem;
}

.term-content ol {
  padding-left: 1.5rem;
}
</style>
